module.exports = __webpack_public_path__ + "5ea1cc10efb9267bc79ee2984e2f854a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/adobe_2023_chart.png
// module id = 1624
// module chunks = 0